import { DownloadOutlined, FileExcelFilled } from "@ant-design/icons";
import { Button, Modal, Table } from "antd";
import inventoryApi from "api/inventory";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ModalMonthlyExport() {
    const [openModal, setOpenModal] = useState(false)
    const [listExports, setListExports] = useState([])

    const { t } = useTranslation()

    const fetchExports = async () => {
        const { data } = await inventoryApi.getMonthlyExport()
        setListExports(data)
    }

    const onDownload = (url) => {
        window.open(url)
    }

    const columns = [
        {
            key: 'month',
            dataIndex: 'month',
            title: t('month'),
        },
        {
            key: 'download',
            dataIndex: 'download',
            title: t('download'),
            render: (_, record) => (
                <Button icon={<DownloadOutlined />} onClick={() => onDownload(record.fileUrl)}/>
            )
        },
    ]

    useEffect(() => {
        fetchExports()
    }, [])

    return (
        <>
            <Button type='primary' icon={<FileExcelFilled />} size='large' onClick={() => setOpenModal(true)}>
                {t('monthlyExport')}
            </Button>
            <Modal
                title={t('monthlyExport')}
                onCancel={() => setOpenModal(false)}
                open={openModal}
                footer=''
            >
                <Table columns={columns} dataSource={listExports} />
            </Modal>
        </>
    )
}
